<template>
  <div class="table-container-main">
    <div class="confirm-svg">
        <svg style="padding-left: 5px;" height="50px" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 156 180.36">
            <g id="image">
                <path d="M83.82,107.32c-.8,.6-1.89,.64-2.73,.09-9.02-5.68-17.02-12.82-23.68-21.13-8.16-9.91-13.64-21.75-15.94-34.38-1.89-11.72-.09-22.99,5.78-32.17,2.37-3.73,5.35-7.03,8.8-9.77C63.62,3.64,73.14,.13,82.99,0c9.55,.15,18.69,3.88,25.62,10.45,2.66,2.44,4.96,5.25,6.84,8.33,6.27,10.27,7.62,23.48,4.86,36.86-4.67,21.46-17.84,40.1-36.49,51.68Zm-26.82,1.36v40.6l44,18.97v-52.69l8-7.93v60.34l37-18.63V67.47l-15.02,5.78c1.51-3.98,2.75-8.06,3.72-12.2l14.53-5.61c2.58-.94,5.44,.36,6.42,2.92,.23,.58,.34,1.19,.34,1.81v92.18c0,1.93-1.16,3.68-2.95,4.42l-45.95,23.08c-1.35,.68-2.95,.68-4.3,0l-51.55-22.34L6.89,179.85c-2.34,1.18-5.19,.25-6.37-2.09,0,0,0,0,0,0C.18,177.09,0,176.36,0,175.62V78.41c0-2.22,1.46-4.17,3.59-4.8l25.36-9.78c.94,3.19,2.06,6.33,3.34,9.4l-22.29,8.59v86.19l37-18.63v-51.2c3.11,3.71,6.45,7.22,10,10.51ZM81.22,20.85c11.12,0,20.13,9.01,20.13,20.13s-9.01,20.13-20.13,20.13-20.13-9.01-20.13-20.13,9.01-20.13,20.13-20.13h0Z" style="fill: #000; fill-rule: evenodd;"/>
            </g>
        </svg>
        <h2>Invoices</h2>
    </div>
    <table-filter :filterByDateRange="true" :filterByAccountNo="true" :filterByInvoiceID="true" @filterValues="filterValues($event)"/>
    <div class="responsive-table">
        <div class="table-header" id="header">
            <div class="col-1">Invoice #</div>
            <div class="col-2">Amount</div>
            <div class="col-3">Paid</div>
            <div class="col-3">Balance</div>
            <div class="col-3">Invoice Date</div>
            <!-- <div class="col-3"><input 
                    type="checkbox" 
                    :value="invoice" 
                    v-model="selectedInvoices" 
                /></div> -->
            <div class="col-3">View PDF</div>
            <div class="col-4"><input 
                type="checkbox" 
                v-model="selectAll" 
                @change="toggleSelectAll"
            /></div>
        </div>
        <loading-charts v-if="loadingTable" class="loading-charts"/>
        <div class="table-row-container">
            <div class="table-row" v-for="(invoice, index) in invoiceTableData" :key="index">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text" @click="getUserDataClick(invoice.invoiceID)">{{invoice.invoiceID}}</p></div>
                <div class="col-2"><p class="service-text">{{formatCurrency(invoice.invoiceTotal)}}</p></div>
                <div class="col-3"><p class="service-text">{{formatCurrency(invoice.paidSum)}}</p></div>
                <div class="col-3"><p class="service-text">{{formatCurrency(invoice.balance)}}</p></div>
                <div class="col-3"><p class="service-text date-text">{{formatDate(invoice.invoicePostDate)}}</p></div>
                <!-- <div class="col-3"><input 
                    type="checkbox" 
                    :value="invoice" 
                    v-model="selectedInvoices" 
                /></div> -->
                <div class="col-3">
                    <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" @click="openInvoice(invoice)" class="download-icon"  viewBox="0 0 24 24" height="15px"><path d="M20,11v8c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5V9c0-2.757,2.243-5,5-5H13c.552,0,1,.448,1,1s-.448,1-1,1H5c-1.654,0-3,1.346-3,3v10c0,1.654,1.346,3,3,3H15c1.654,0,3-1.346,3-3V11c0-.552,.448-1,1-1s1,.448,1,1ZM21,0h-7c-.552,0-1,.448-1,1s.448,1,1,1h6.586L8.293,14.293c-.391,.391-.391,1.023,0,1.414,.195,.195,.451,.293,.707,.293s.512-.098,.707-.293L22,3.414v6.586c0,.552,.448,1,1,1s1-.448,1-1V3c0-1.654-1.346-3-3-3Z"/></svg>
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" @click="openInvoice(invoice)" class="download-icon" id="Outline" viewBox="0 0 24 24" height="15px"><path d="M9.878,18.122a3,3,0,0,0,4.244,0l3.211-3.211A1,1,0,0,0,15.919,13.5l-2.926,2.927L13,1a1,1,0,0,0-1-1h0a1,1,0,0,0-1,1l-.009,15.408L8.081,13.5a1,1,0,0,0-1.414,1.415Z"/><path d="M23,16h0a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V17a1,1,0,0,0-1-1H1a1,1,0,0,0-1,1v4a3,3,0,0,0,3,3H21a3,3,0,0,0,3-3V17A1,1,0,0,0,23,16Z"/></svg> -->
                </div>
                <div class="col-4"><input 
                    type="checkbox" 
                    :value="invoice" 
                    v-model="selectedInvoices" 
                /></div>
            </div>
            <div v-if="invoiceTableData.length == 0" class="table-row">
                <div class="col-1"><p class="shipmentid-text" id="shipmentid-text"></p></div>
                <div class="col-2 col-data">No Invoices</div>
                <div class="col-3 col-data"><p class="service-text"></p></div>
            </div>
        </div>
    </div>
  </div>
<div class="button-container">
    <div class="print-selected close-label">
        <p class="print-selected-text download-csv" @click="downloadCSVTest()">Download CSV</p>
    </div>
</div>
<admin-invoice-info v-if="toggleAddressBookInfo" @closeAddressInfo="closeAddressInfo($event)" :invoiceID="invoiceID"/>
<alert-user  v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue'
import AdminInvoiceInfo from '../BillingDashboard/AdminInvoiceInfo.vue'
import TableFilter from '../TableFilter.vue'
import jsonexport from 'jsonexport'

export default {
    components:{
        AlertUser,
        LoadingCharts,
        AdminInvoiceInfo,
        TableFilter
    },
    props: ['userData'],
    data(){
        return{
            toggleAddressBookInfo: false,
            id: null,
            serviceNetwork: null,
            invoiceTableData: [],
            loadingTable: false,
            toggleAlertBox: '',
            alertMessage: '',
            filterField: null,
            filterValue: null,
            filterEvent: null,
            isFiltered: false,
            invoiceCheckBox: false,
            invoiceID: null,
            selectedInvoices: [],
            selectAll: false 
        }
    },
    methods:{
        toggleSelectAll() {
            if (this.selectAll) {
                // Select all invoices
                this.selectedInvoices = [...this.invoiceTableData];
            } else {
                // Deselect all
                this.selectedInvoices = [];
            }
        },
        async downloadInvoice(invoice) {
            const url = invoice?.invoiceURL;
            if (!url) {
            console.warn('No invoiceURL on invoice:', invoice);
            return;
            }
            try {
            const res = await fetch(url, { credentials: 'omit' }); // presigned S3 usually OK
            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const blob = await res.blob();
            const objectUrl = URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = objectUrl;
            a.download = `${invoice.invoiceID || 'invoice'}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();
            URL.revokeObjectURL(objectUrl);
            } catch (err) {
            console.error('Download failed:', err);
            // optionally surface a toast/alert for the user here
            }
        },
        // async openInvoice(invoice) {
        //     const url = invoice?.invoiceURL;
        //     if (!url) {
        //         console.warn("No invoiceURL on invoice:", invoice);
        //         return;
        //     }
        //     try {
        //         const res = await fetch(url, { credentials: "omit" });
        //         if (!res.ok) throw new Error(`HTTP ${res.status}`);

        //         const blob = await res.blob();
        //         const objectUrl = URL.createObjectURL(blob);

        //         // Open in a new tab instead of downloading
        //         window.open(objectUrl, "_blank");

        //         // Optionally, revoke the URL after some delay to ensure the tab loads
        //         setTimeout(() => URL.revokeObjectURL(objectUrl), 60000);
        //     } catch (err) {
        //         console.error("Open invoice failed:", err);
        //     }
        // },
        async openInvoice(invoice) {
            const url = invoice?.invoiceURL;
            if (!url) {
                console.log("No invoiceURL on invoice:", invoice);
                return;
            }
            window.open(url, "_blank");
        },
        formatCurrency(value) {
            return `$${parseFloat(value).toFixed(2)}`;
        },
        formatDate(value) {
            const [year, month, day] = value.split("-");
            const date = new Date(Number(year), Number(month) - 1, Number(day)); 
            return date.toLocaleDateString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
            });
        },
        async objectsArrayToCSV(invoice, filename = "data.csv") {
            let dataArray = [];
            dataArray.push(invoice)
            // Define headers in the CSV
            const headers = [
                "New", "Transaction Date", "Type", "Doc Number", "Payment Method",
                "Name", "Transaction Account", "Account", "Amount", "Comment", "CustomerNo"
            ];

            const csvRows = [headers.join(",")];

            dataArray.forEach(item => {
                const row = [
                    "Yes", // "New"
                    item.invoicePostDate || "", // "Transaction Date"
                    "Payment",
                    item.invoiceID || "", // "Doc Number"
                    "Credit", // "Payment Method"
                    "", // "Name"
                    "", // "Transaction Account"
                    item.accountNo || "", // "Account"
                    item.paidSum || "", // "Amount"
                    "", // "Comment"
                    item.accountNo || "" // "CustomerNo"
                ];
                csvRows.push(row.join(","));
            });

            const csvString = csvRows.join("\n");
            const blob = new Blob([csvString], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        async exportInvoiceData(invoiceIdentifier){
            await this.getInvoiceData(invoiceIdentifier)
            const { accountNo, balance, invoiceID, invoicePostDate, invoiceTotal, paidSum, status } = this.invoiceData;
            console.log(this.invoiceData)
            const formattedDate = new Date(invoicePostDate).toLocaleString("en-US", {
                month: "long",
                day: "numeric",
                year: "numeric",
                hour: "numeric",
                minute: "2-digit",
                hour12: true
            });

            const invoiceHTML = `
                <html>
                    <head>
                        <title>Invoice ${invoiceID}</title>
                        <style>
                            body { font-family: Arial, sans-serif; margin: 20px; }
                            h1 { color: #333; }
                            p { margin: 5px 0; }
                            .invoice-details { margin-top: 20px; }
                            .detail { font-weight: bold; }
                        </style>
                    </head>
                    <body>
                        <h1>Invoice Details</h1>
                        <p><span class="detail">Invoice ID:</span> ${invoiceID}</p>
                        <p><span class="detail">Account No:</span> ${accountNo}</p>
                        <p><span class="detail">Invoice Date:</span> ${formattedDate}</p>
                        <p><span class="detail">Invoice Total:</span> $${invoiceTotal}</p>
                        <p><span class="detail">Paid Sum:</span> $${paidSum}</p>
                        <p><span class="detail">Balance:</span> $${balance}</p>
                        <p><span class="detail">Status:</span> ${status === "O" ? "Open" : "Closed"}</p>
                        <hr />
                        <p>Thank you for your choosing LREX!</p>
                    </body>
                </html>
            `;

            const printWindow = window.open("", "_blank");
            printWindow.document.write(invoiceHTML);
            printWindow.document.close();

            printWindow.onload = function () {
                printWindow.print();
                printWindow.close();
            };
        },
        filterValues(event){
            this.isFiltered = true;
            this.filterEvent = event;
            this.filterField = event.filterField;
            this.filterValue = event.filterValue;
            this.invoiceCheckBox = event.invoiceCheckBox;

            switch (event.filterField) {
                case "invoiceID":
                    this.getInvoiceByInvoiceID(event.filterValue)
                    break;
                case "accountNo":
                    this.invoicesByAccountNo(event.filterValue)
                    break;
                case "dateRange":
                    console.log(event)
                    this.invoicesByAccountNo(event.filterValue, event.startDate, event.endDate, event.filterField)
                    break;
                default:
                    break;
            }
        },
        async getInvoiceData(invoiceID){
            this.loadingTable = true;
            let graphqlQuery = `query getInvoice {
                getInvoice(invoiceID: "${invoiceID}") {
                    accountNo
                    invoiceID
                    status
                    paidSum
                    balance
                    invoicePostDate
                    invoiceTotal
                    invoiceURL
                    billingAddress{
                        address1
                        address2
                        attention
                        city
                        companyName
                        email
                        phone
                        routeCode
                        state
                        zipCode
                    }
                }
            }`
            console.log(graphqlQuery)
            try{
                let getInvoices = await API.graphql({
                query:  graphqlQuery,
                authMode: "AMAZON_COGNITO_USER_POOLS",
                })

                if(getInvoices.data.getInvoice && getInvoices.data.getInvoice.invoiceID){
                    this.invoiceData = getInvoices.data.getInvoice;
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting invoice"
                }
            }catch(e){
                console.log(e)
                if(e){
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting invoice"
                }
            }finally{
                this.loadingTable = false;
                this.isFiltered = false;
            }
        },
        async getInvoiceByInvoiceID(filterValue) {
            this.loadingTable = true;
            this.invoiceTableData = [];

            let getInvoice = `query getInvoice {
                getInvoice(invoiceID: "${filterValue}") {
                    accountNo
                    invoiceID
                    status
                    paidSum
                    balance
                    invoicePostDate
                    invoiceTotal
                    invoiceURL
                    billingAddress{
                        address1
                        address2
                        attention
                        city
                        companyName
                        email
                        phone
                        routeCode
                        state
                        zipCode
                    }
                }
            }`;

            try {
                let getInvoices = await API.graphql({
                    query: getInvoice,
                    variables: {
                        invoiceID: filterValue
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                });
                console.log(getInvoices.data.getInvoice)
                if(getInvoices.data.getInvoice && getInvoices.data.getInvoice.invoiceID){
                    this.invoiceTableData.push(getInvoices.data.getInvoice)
                }else{
                    this.invoiceTableData = []
                }

            } catch (e) {
                this.toggleAlertBox = true;
                this.alertMessage = "Error getting invoice data";
                this.loadingTable = false;
            }

            this.loadingTable = false;
        },
        async invoicesByAccountNo(filterValue, startDate, endDate, filterField) {
            this.loadingTable = true;
            let nextToken = null;
            this.invoiceTableData = [];
            let invoiceByAccountNo;
            let filterByDateRange = false;
            if(filterField == 'dateRange'){filterByDateRange = true}
            let filterDateRange = `,filter: {invoicePostDate: {between: ["${startDate}", "${endDate}"]}}`
            const dateFilter = filterByDateRange ? `, ${filterDateRange}` : '';

            if(this.invoiceCheckBox){
                invoiceByAccountNo = `query invoiceByAccountNo {
                    invoiceByAccountNo(accountNo: "${filterValue}", status: {eq: "O"}${dateFilter}, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                        items {
                            accountNo
                            invoiceID
                            status
                            paidSum
                            balance
                            invoicePostDate
                            invoiceTotal
                            invoiceURL
                            billingAddress{
                                address1
                                address2
                                attention
                                city
                                companyName
                                email
                                phone
                                routeCode
                                state
                                zipCode
                            }
                        }
                        nextToken
                    }
                }`
            }else{
                invoiceByAccountNo = `query invoiceByAccountNo {
                    invoiceByAccountNo(accountNo: "${filterValue}"${dateFilter}, nextToken: ${nextToken ? `"${nextToken}"` : null}) {
                        items {
                            accountNo
                            invoiceID
                            status
                            paidSum
                            balance
                            invoicePostDate
                            invoiceTotal
                            invoiceURL
                            billingAddress{
                                address1
                                address2
                                attention
                                city
                                companyName
                                email
                                phone
                                routeCode
                                state
                                zipCode
                            }
                        }
                        nextToken
                    }
                }`
            }

            do {
                try {
                    let getInvoices = await API.graphql({
                        query: invoiceByAccountNo,
                        variables: {
                            accountNo: filterValue,
                            nextToken
                        },
                        authMode: "AMAZON_COGNITO_USER_POOLS",
                    });

                    const { items, nextToken: newNextToken } = getInvoices.data.invoiceByAccountNo;
                    this.invoiceTableData = this.invoiceTableData.concat(items);
                    this.invoiceTableData = this.invoiceTableData.sort(
                        (a, b) => new Date(a.invoicePostDate) - new Date(b.invoicePostDate)
                    );
                    nextToken = newNextToken;

                } catch (e) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error getting invoice data";
                    this.loadingTable = false;
                    break; // Exit the loop if there's an error
                }
            } while (nextToken);

            this.loadingTable = false;
        },
        async getUserDataClick(invoiceID){
            this.invoiceID = invoiceID
            this.toggleAddressBookInfo = true;
        },
        closeAddressInfo(event){
            this.toggleAddressBookInfo = event;
            if(this.isFiltered == true){
                this.filterValues(this.filterEvent);
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
        },
        async downloadCSVTest(){
            this.loadingTable = true;
            let csvArray;
            csvArray = this.selectedInvoices.map(inv =>{
                const addr = inv?.billingAddress ?? {};
                return {
                    accountNo: inv?.accountNo ?? '',
                    invoiceID: inv?.invoiceID ?? '',
                    status: inv?.status ?? '',
                    paidSum: inv?.paidSum ?? '',
                    balance: inv?.balance ?? '',
                    invoicePostDate: inv?.invoicePostDate ?? '',
                    invoiceTotal: inv?.invoiceTotal ?? '',
                    billing_address1: addr?.address1 ?? '',
                    billing_address2: addr?.address2 ?? '',
                    billing_attention: addr?.attention ?? '',
                    billing_city: addr?.city ?? '',
                    billing_companyName: addr?.companyName ?? '',
                    billing_email: addr?.email ?? '',
                    billing_phone: addr?.phone ?? '',
                    billing_routeCode: addr?.routeCode ?? '',
                    billing_state: addr?.state ?? '',
                    billing_zipCode: addr?.zipCode ?? '',
                };
            })
            jsonexport(csvArray, (error, csv) => {
                if (error) {
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error downloading invoices"
                }
                const blob = new Blob([csv], { type: 'text/csv' });
                const anchor = document.createElement('a');
                anchor.href = window.URL.createObjectURL(blob);
                anchor.download = 'Invoice.csv';
                anchor.click();
                window.URL.revokeObjectURL(anchor.href);
                anchor.remove();
                this.loadingTable = false;
            })
        }
    }
}
</script>

<style scoped>
h3{
    margin: 0;
}
.table-container-main{
    width: 100%;
    margin-top: 0;
    overflow-x: hidden;
}

.responsive-table{
    width: 100%;
}

.confirm-svg{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #e4e4e4;
    border-radius: 999px;
    padding: 5px;
    width: fit-content;
    margin-bottom: 5px;
}

.confirm-svg svg{
    width: 35px;
    height: 35px;
    padding-right: 5px;
}

.confirm-svg h2{
    margin: 0;
}

* {
    scrollbar-width: auto;
    scrollbar-color: #f3f3f3 #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
    width: 16px;
}

*::-webkit-scrollbar-track {
    background: #ffffff;
}

*::-webkit-scrollbar-thumb {
    background-color: #f3f3f3;
    border-radius: 10px;
    border: 3px solid #ffffff;
}

.table-header{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #32ccfe;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
    color: #fff;
}

.table-row-container{
    max-height: 350px;
    overflow-y: auto;
    border-radius: 5px;
    width: 100%;
    animation: animate-table-row 1s ease;
}

@keyframes animate-table-row{
    from{
        margin-left: -50px;
    }
    to{
        margin-left: 0px;
    }
}

.table-row{
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: #f3f3f3;
    margin-bottom: 10px;
    padding: 5px;
    border-radius: 5px;
    /* width: calc(100% - 20px); */
}

.table-header .col-1{
    margin-right: 5px;
}

.col-1{
    flex-basis: 20%;
    text-align: left;
    /* white-space: nowrap; */
}

.col-2{
    flex-basis: 40%;
    text-align: left;
    margin-left: 5px;
}

.col-3{
    flex-basis: 30%;
    text-align: left;
    margin-left: 5px;
}

.col-data{
    text-align: left;
    max-height: 40px;
    overflow-y: auto;
    /* border: 1px solid #a0a0a0; */
    border-radius: 5px 0px 0px 5px;
}

.col-data p{
    overflow-x: auto;
    margin-top: 5px;
    margin-bottom: 5px;
}

.col-4{
    flex-basis: 10%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
}

.service-text{
    background-color: #d4d4d4;
    padding: 2.5px 10px;
    border-radius: 999px;
    width: fit-content;
    margin: 0;
    font-size: 12px;
}

.date-text{
    background-color: transparent;
    padding: 0;
}

.export-text{
    cursor: pointer;
    transition-duration: .25s;

    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
}

.export-text:hover{
    cursor: pointer;
    filter: brightness(0.9);
    transition-duration: .25s;
}

.download-icon{
    cursor: pointer;
    transition-duration: .25s;

    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
}

.download-icon:hover{
    cursor: pointer;
    filter: brightness(0.9);
    transition-duration: .25s;
}

.shipmentid-text{
    margin: 0;
    color: #6a6a6a;
    width: fit-content;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.shipmentid-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

input[type="checkbox"] {
    /* Add if not using autoprefixer */
    -webkit-appearance: none;
    /* Remove most all native input styles */
    appearance: none;
    /* For iOS < 15 */
    background-color: #fff;
    /* Not removed via appearance */
    margin: 0;
    cursor: pointer;

    font: inherit;
    color: #33f18a;
    width: 1.05em;
    height: 1.05em;
    border: 0.15em solid #33f18a;
    border-radius: 0.15em;
    /* transform: translateY(-0.075em); */

    display: grid;
    place-content: center;
    transition-duration: .5s;
}

input[type="checkbox"]:hover{
    background-color: #f3f3f3;
    transition-duration: .5s;
}

input[type="checkbox"]::before {
    content: "";
    width: 0.65em;
    height: 0.65em;
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
    transform: scale(0);
    transform-origin: bottom left;
    transition: 120ms transform ease-in-out;
    box-shadow: inset 1em 1em var(--form-control-color);
    /* Windows High Contrast Mode */
    background-color: CanvasText;
}

input[type="checkbox"]:checked::before {
    transform: scale(1);
}

.button-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin: 0;
    animation: animate-table-row 1s ease;
}

.print-selected-text{
    margin: 0;
    margin-bottom: 5px;
    margin-right: 5px;
    padding: 2.5px 10px;
    border-radius: 999px;
    background-color: #f3f3f3;
    border: 1px solid #a0a0a0;
    transition-duration: .5s;
}

.download-csv{
    margin-top: 5px;
}

.void-selected-text{
    margin: 0;
    margin-bottom: 5px;
    padding: 2.5px 10px;
    margin-bottom: 5px;
    border-radius: 999px;
    background-color: #fe804d;
    border: 1px solid #ff5512;
    color: #fff;
    transition-duration: .5s;
}

.print-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.void-selected-text:hover{
    filter: brightness(0.9);
    cursor: pointer;
    transition-duration: .5s;
}

.close-label{
    margin-left: auto;
}

.label-container{
    width: 100%;
}

@media only screen and (max-width: 600px) {
    .service-text, .col-data{
        font-size: 8px;
    }

    .shipmentid-text{
        font-size: 10px;
    }
}
</style>